const reducer = (state = {}, action) => {
  switch (action.type) {
    case "FETCH_MY_LAB":
      return action.payload;
    case "CLEAR_MY_LAB":
      return {};
    default:
      return state;
  }
};
export default reducer;
